export default __webpack_public_path__ + "static/media/alert.c4da078b.svg";